/**
 * GST Report — focused view of the GST column from the tax engine.
 * Routed at `/reports/gst`. See TaxReportPage for the shared renderer.
 */
import React from 'react';
import TaxReportPage from './TaxReportPage';

const GSTReport = () => (
  <TaxReportPage
    taxKey="gst"
    title="GST Report"
    subtitle="Monthly GST collected vs deposited to govt (GSTR-3B) — track deposits, challans & return filing."
  />
);

export default GSTReport;
